// src/Pages/Contact/Contact.js
import React from "react";
import { useTranslation } from "react-i18next";
import "./Contact.css";

function ContactUs() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return React.createElement(
    "main",
    {
      className: "page container contact-page " + (isRTL ? "rtl" : "ltr"),
      dir: isRTL ? "rtl" : "ltr",
    },
    // <section>
    React.createElement(
      "section",
      { className: "page-section" },

      // section title
      React.createElement(
        "div",
        { className: "section-title" },
        React.createElement("h3", null, t("Contact Title")),
        React.createElement(
          "div",
          { className: "muted" },
          t("Contact Subtitle")
        )
      ),

      // layout wrapper
      React.createElement(
        "div",
        { className: "contact-layout" },

        // LEFT: form
        React.createElement(
          "div",
          null,
          React.createElement(
            "form",
            {
              id: "contact-form-react",
              onSubmit: function (e) {
                e.preventDefault();
                // simple mock submit – same idea as HTML
                alert(
                  t(
                    "Contact Thanks Message",
                    "Thanks! Your message was (mock) sent — integrate your backend endpoint to make this real."
                  )
                );
                e.target.reset();
              },
            },
            React.createElement(
              "div",
              { className: "contact-form-grid" },

              React.createElement("input", {
                name: "name",
                placeholder: t("Contact Name Placeholder"),
                required: true,
              }),
              React.createElement("input", {
                name: "email",
                placeholder: t("Contact Email Placeholder"),
                required: true,
                type: "email",
              }),
              React.createElement("textarea", {
                name: "message",
                rows: 6,
                placeholder: t("Contact Message Placeholder"),
                required: true,
              }),
              React.createElement(
                "button",
                { className: "btn", type: "submit" },
                t("Contact Submit Button")
              )
            )
          )
        ),

        // RIGHT: aside box
        React.createElement(
          "aside",
          { className: "contact-aside" },
          React.createElement("h4", null, t("Contact Office Title")),
          React.createElement(
            "p",
            { className: "muted" },
            t("Contact Office Text")
          )
        )
      )
    )
  );
}

export default ContactUs;
